/**
@namespace NetRelations
*/
netr = {};